import { GetterTree } from 'vuex';
import { LayoutState, RootState } from '../types';

export const getters: GetterTree<LayoutState, RootState> = {
	isTabBarDisplayed(state: LayoutState): boolean {
		return state.tabBar;
	}
};